// src/components/filters/SpaceFilter.tsx
import React from 'react';
import { useSpaces } from '../../hooks/data/useSpaces'; 
import { FilterState } from '../../hooks/useFilters';

interface SpaceFilterProps {
  token: string | null;
  selectedSpaceId: string | null;
  onSpaceChange: (spaceId: string | null) => void;
}

const SpaceFilter: React.FC<SpaceFilterProps> = ({ 
  token, 
  selectedSpaceId, 
  onSpaceChange 
}) => {
  // Fetch spaces using our hook
  const { spaces, isLoading, error } = useSpaces(token);
  
  // Handle space selection
  const handleSpaceChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    onSpaceChange(value === '' ? null : value);
  };
  
  // If there's an error, show an error message
  if (error) {
    return <div className="space-filter-error">Error loading spaces: {error}</div>;
  }
  
  return (
    <div className="space-filter">
      <label htmlFor="space-select">Filter by Space:</label>
      <select
        id="space-select"
        value={selectedSpaceId || ''}
        onChange={handleSpaceChange}
        disabled={isLoading}
        className="space-select"
      >
        <option value="">All Spaces</option>
        {spaces.map(space => (
          <option key={space.id} value={space.id}>
            {space.name}
          </option>
        ))}
      </select>
      {isLoading && <span className="loading-indicator">Loading spaces...</span>}
    </div>
  );
};

export default SpaceFilter;